import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrmHeroComponent } from '../../Components/Crm/crm-hero/crm-hero';
import { CrmGlanceComponent } from '../../Components/Crm/crm-glance/crm-glance';
import { CrmPipelineComponent } from '../../Components/Crm/crm-pipeline/crm-pipeline';
import { CrmWorkflowComponent } from '../../Components/Crm/crm-workflow/crm-workflow';
import { CrmMobileComponent } from '../../Components/Crm/crm-mobile/crm-mobile';
import { CrmCtaComponent } from '../../Components/Crm/crm-cta/crm-cta';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-crm-page',
  standalone: true,
  imports: [
    CommonModule,
    CrmHeroComponent,
    CrmGlanceComponent,
    CrmPipelineComponent,
    CrmWorkflowComponent,
    CrmMobileComponent,
    CrmCtaComponent,
  ],
  templateUrl: './crm-page.html',
  styleUrls: ['./crm-page.css'],
})
export class CrmPageComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'CRM Software',
      description:
        'Manage leads, deals, and customer conversations in one place with orderYaa CRM — part of the orderYaa ERP suite.',
      path: '/crm',
      robots: 'noindex, follow',
    });
  }
}
